import { Button, Grid } from '@material-ui/core';
import { ModalHeader } from 'views/components/modals/components/modal-header/modal-header';
import { ButtonModalHeader } from 'views/components/controles/buttons/button-modal-header/button-modal-header';
import {
    SalvarNovoIcon,
    VoltarIcon,
} from 'views/components/icons';
import { useModalStyles } from 'views/components/modals/utils/modal-styles';
import { CircularLoading } from 'views/components/utils/circular-loading/circular-loading';
import classNames from 'classnames';
import { useCallback, useEffect, useRef } from 'react';
import { useCadastros, useToastSaurus } from 'services/app';
import { DefaultFormRefs } from 'views/components/form/utils';
import { usePostAdicionarPessoa } from 'data/api/gestao/pessoa';
import { PessoaModel } from 'model/api/gestao/pessoa/pessoa-model';
import { EnumTipoPessoas } from 'model/enums/enum-tipo-pessoas';
import { PessoaPostModel } from 'model/api/gestao/pessoa/pessoa-post-model';
import { FormRepresentanteCadastro } from 'views/components/form/master/pessoa/representante-cadastro/form-representante-cadastro';

export const RepresentantesCadastro = () => {


    const classes = useModalStyles();

    const { fecharCadastroRepresentantes } = useCadastros()

    const refForm = useRef<DefaultFormRefs<PessoaPostModel>>(null)
    const refNovo = useRef<boolean>(true)

    const { postAdicionarPessoa, carregando: carregandoPost } = usePostAdicionarPessoa();

    const { showToast } = useToastSaurus()

    useEffect(() => {
        refForm.current?.fillForm(new PessoaPostModel('', EnumTipoPessoas.Representante))
    }, [])

    const carregando = carregandoPost

    const handleSubmit = useCallback(async (model: PessoaPostModel) => {
        try {
            const res = await postAdicionarPessoa(model)

            if (res.erro) throw res.erro

            const ret = res.resultado?.data as PessoaModel
            if (refNovo.current) {
                refForm.current?.resetForm()
                showToast('success', 'Representante cadastrado')
                return
            }

            fecharCadastroRepresentantes(`/representantes/${ret.id}`)

            showToast('success', 'Representante cadastrado')
        }
        catch (err: any) {
            showToast('error', err.message)
        }
    }, [fecharCadastroRepresentantes, postAdicionarPessoa, showToast])


    return (
        <div className={classes.root}>
            {carregando ? <CircularLoading tipo="FULLSIZED" /> : null}
            <ModalHeader
                title='Novo Representante'
                leftArea={
                    <ButtonModalHeader
                        tooltip="Voltar"
                        icon={<VoltarIcon tipo="MODAL_HEADER" />}
                        onClick={() => fecharCadastroRepresentantes()}
                    />
                }
            />
            <div className={classes.content}>
                <div
                    className={classNames(
                        classes.contentForms,
                        carregando ? classes.contentFormsLoading : undefined,
                    )}
                >
                    <FormRepresentanteCadastro
                        ref={refForm}
                        loading={carregando}
                        showLoading={false}
                        onSubmit={handleSubmit}
                    />
                </div>
                <div className={classes.acoes}>
                    <Grid container spacing={2}>
                        <Grid item xs={12} lg={7}>
                            <Button
                                disabled={carregando}
                                onClick={() => {
                                    refNovo.current = true
                                    refForm.current?.submitForm()
                                }}
                                variant="outlined"
                                color="primary"
                                size="large"
                                fullWidth
                            >
                                <SalvarNovoIcon tipo="BUTTON" />
                                Salvar e Adicionar Novo
                            </Button>
                        </Grid>
                        <Grid item xs={12} lg={5}>
                            <Button
                                disabled={carregando}
                                onClick={() => {
                                    refNovo.current = false
                                    refForm.current?.submitForm()
                                }}
                                variant="contained"
                                color="primary"
                                size="large"
                                fullWidth
                            >
                                <SalvarNovoIcon tipo="BUTTON_PRIMARY" />
                                Salvar e Editar
                            </Button>
                        </Grid>
                    </Grid>
                </div>
            </div>
        </div>
    );
};